import 'whatwg-fetch';
import { presence } from 'src/chemkit';

export default class MessagesFetcher {
  static configuration() {
    return fetch('/api/v1/messages/config.json', {
      credentials: 'same-origin'
    }).then((response) => response.json()).then((json) => json).catch((errorMessage) => {
      console.log(errorMessage);
    });
  }

  static fetchMessages(isAck) {
    return fetch(`/api/v1/messages/list.json?is_ack=${isAck}`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        ...presence.chemkitClientIdHeader(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(presence.buildMessagesBody()),
    }).then((response) => response.json()).then(presence.publishStaleWarnings).catch((errorMessage) => {
      console.log(errorMessage);
      return { messages: [] };
    });
  }

  static fetchSpectraMessages(isAck) {
    return fetch(`/api/v1/messages/spectra.json?is_ack=${isAck}`, {
      credentials: 'same-origin'
    }).then((response) => response.json()).then((json) => json).catch((errorMessage) => {
      console.log(errorMessage);
      return { messages: [] };
    });
  }

  static fetchChannels(channelType) {
    return fetch(`/api/v1/messages/channels.json?channel_type=${channelType}`, {
      credentials: 'same-origin'
    }).then((response) => response.json()).then((json) => json).catch((errorMessage) => {
      console.log(errorMessage);
    });
  }

  static fetchChannelWithUser() {
    return fetch('/api/v1/messages/channels_user.json', {
      credentials: 'same-origin'
    }).then((response) => response.json()).then((json) => json).catch((errorMessage) => {
      console.log(errorMessage);
    });
  }

  static channelIndividualUsers() {
    return fetch('/api/v1/messages/channel_individual.json', {
      credentials: 'same-origin'
    }).then((response) => response.json()).then((json) => json).catch((errorMessage) => {
      console.log(errorMessage);
    });
  }

  static acknowledgedMessage(params) {
    return fetch('/api/v1/messages/ack/', {
      credentials: 'same-origin',
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...presence.chemkitClientIdHeader(),
      },
      body: JSON.stringify(params)
    }).then((response) => response.json()).then((json) => json).catch((errorMessage) => {
      console.log(errorMessage);
    });
  }

  static subscribeChannel(params) {
    return fetch('/api/v1/messages/subscribe/', {
      credentials: 'same-origin',
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(params)
    }).then((response) => response.json()).then((json) => json).catch((errorMessage) => {
      console.log(errorMessage);
    });
  }

  static createMessage(params) {
    return fetch('/api/v1/messages/new/', {
      credentials: 'same-origin',
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(params)
    }).then((response) => response.json()).then((json) => json).catch((errorMessage) => {
      console.log(errorMessage);
    });
  }
}
